/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import Props from './Props';
import State from './State';
import PhoneVerificationCodeButtons from '../PhoneVerificationCodeButtons';
import PhoneVerificationCodeInput from '../PhoneVerificationCodeInput';
import {ConstraintViolationDTO} from '../../model/validation';

class PhoneVerificationCode extends React.Component<Props, State> {

	static defaultProps: Props = {
		maximumDurationInSeconds: null,
		onRetryPhoneVerificationStart: () => {
			// do nothing
		},
		onSubmitVerificationCode: () => {
			// do nothing
		},
		onSubmitVerificationRestart: () => {
			// do nothing
		},
		onVerificationCodeChange: () => {
			// do nothing
		},
		submitDisabled: false,
		verificationStopped: false,
		violations: []
	};

	constructor(props: Props) {
		super(props);

		this.state = {verificationCode: ''};
	}

	handleVerificationCodeChange = (verificationCode: string): void => {
		const props: Readonly<Props> = this.props;

		this.setState({verificationCode});

		props.onVerificationCodeChange();
	};

	handleSubmitVerificationCode = (): void => {
		const props: Readonly<Props> = this.props;
		const state: Readonly<State> = this.state;

		if (!props.submitDisabled)
			props.onSubmitVerificationCode(state.verificationCode);
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;
		const state: Readonly<State> = this.state;

		const verificationCode: string = state.verificationCode;

		const maximumDurationInSeconds: number | null = props.maximumDurationInSeconds;
		const verificationStopped: boolean = props.verificationStopped;
		const violations: ConstraintViolationDTO[] = props.violations;
		const submitDisabled: boolean = props.submitDisabled;
		const onSubmitVerificationRestart: () => void = props.onSubmitVerificationRestart;
		const onRetryPhoneVerificationStart: () => void = props.onRetryPhoneVerificationStart;

		return (
			<React.Fragment>
				<PhoneVerificationCodeInput
					verificationCode={verificationCode}
					autoFocus={true}
					maximumDurationInSeconds={maximumDurationInSeconds}
					verificationStopped={verificationStopped}
					violations={violations}
					onVerificationCodeChange={this.handleVerificationCodeChange}
					onVerificationCodeEnter={this.handleSubmitVerificationCode}/>
				<PhoneVerificationCodeButtons
					verificationStopped={verificationStopped}
					submitDisabled={submitDisabled}
					onSubmitVerificationCode={this.handleSubmitVerificationCode}
					onIndicateVerificationCodeNotReceived={onSubmitVerificationRestart}
					onRetryPhoneVerificationStart={onRetryPhoneVerificationStart}/>
			</React.Fragment>
		);
	}
}

export default PhoneVerificationCode;
